import React, { useCallback } from 'react'
import { sendToNative } from '@mobi/web-native-comms/web'
import { isReactNativeApp } from '@mobi/web-native-comms/web'

import { Footer } from './Components/Footer'
import { appHistory } from '@core/Utils/routing/history'
import { useLogon } from '@core/Utils/hooks'
import { AppRoutes } from '@core/AppRoutes'

export const HomeFooter: React.FC = () => {
  const { isLoggedIn } = useLogon()
  const [showDeveloperOptions, setShowDeveloperOptions] = React.useState(0)

  const onSetDepositLimitClick = useCallback(() => {
    if (isLoggedIn) {
      appHistory.push(AppRoutes.DepositLimits)
    } else {
      window.open('https://help.tabtouch.com.au/knowledge-base/setting-up-your-deposit-limit/')
    }
  }, [isLoggedIn])

  const onVersionNumberClick = useCallback(() => {
    if (!isReactNativeApp) {
      return
    }

    if (showDeveloperOptions >= 4) {
      sendToNative('REQUEST_NATIVE_NAVIGATION', { location: 'Developer Options' })
      setShowDeveloperOptions(0)
    } else {
      setShowDeveloperOptions(curr => ++curr)
    }
  }, [showDeveloperOptions])

  return (
    <Footer
      onSetDepositLimitClick={onSetDepositLimitClick}
      onCopyrightClick={onVersionNumberClick}
    />
  )
}
